module.exports = __webpack_public_path__ + "img/empty.934308c6.png";